import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Home from './pages/Home';
import AboutUs from './pages/About';
import Services from './pages/Services';
import Rooms from './pages/Rooms';
import Contact from './pages/Contact';
import Feedback from './pages/Feedback';
import Gallary from './pages/Gallary';
import Registration from './pages/Registesion';
import Login from './pages/Login';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Routes>
      {/* Default Route to Home */}
      <Route path="/" element={<Navigate to="/home" replace />} />
      
      {/* Home Route */}
      <Route path="/home" element={<Home />} />
      
      {/* Other Routes */}
      <Route path="/about" element={<AboutUs />} />
      <Route path="/services" element={<Services />} />
      <Route path="/rooms" element={<Rooms />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/feedback" element={<Feedback />} />
      <Route path="/gallary" element={<Gallary />} />
      <Route path="/login" element={<Login />} />
      <Route path="/registration" element={<Registration />} />
    </Routes>
  </Router>
);

// Performance reporting
reportWebVitals();
